import extReducers from './reducers';
import extActions from './actions';
export default extReducers;

// export { default as extActionTypes } from "./action-types";
export { default as extActions } from './actions';
export { default as extMiddleware } from "./middlewares";
export type IExtActions = typeof extActions;
